// Q360-METHOD
// LOT 2.6.6.7 — Admin Framework Action Integration
//
// Frontend orchestration only.
//
// This module:
// - does not own Employee business rules;
// - does not own lifecycle rules;
// - does not own company authority;
// - does not own RBAC;
// - does not render UI;
// - does not create Admin Framework primitives.

export const EMPLOYEE_ADMIN_ACTION_STATUS =
  Object.freeze({
    IDLE: "idle",
    PENDING: "pending",
    SUCCESS: "success",
    VALIDATION_ERROR: "validation_error",
    FORBIDDEN: "forbidden",
    NOT_FOUND: "not_found",
    CONFLICT: "conflict",
    GENERIC_ERROR: "generic_error",
  });

export function classifyEmployeeAdminActionError(
  error,
) {
  const status =
    error?.response?.status;

  switch (status) {
    case 400:
      return (
        EMPLOYEE_ADMIN_ACTION_STATUS
          .VALIDATION_ERROR
      );

    case 403:
      return (
        EMPLOYEE_ADMIN_ACTION_STATUS
          .FORBIDDEN
      );

    case 404:
      return (
        EMPLOYEE_ADMIN_ACTION_STATUS
          .NOT_FOUND
      );

    case 409:
      return (
        EMPLOYEE_ADMIN_ACTION_STATUS
          .CONFLICT
      );

    default:
      return (
        EMPLOYEE_ADMIN_ACTION_STATUS
          .GENERIC_ERROR
      );
  }
}

export function createEmployeeAdminActionRunner({
  onStateChange = () => {},
} = {}) {
  let pending = false;

  const emit = (state) => {
    onStateChange(state);
    return state;
  };

  const run = async (action) => {
    if (typeof action !== "function") {
      throw new TypeError(
        "Employee admin action must be a function.",
      );
    }

    if (pending) {
      return {
        accepted: false,
        status:
          EMPLOYEE_ADMIN_ACTION_STATUS.PENDING,
      };
    }

    pending = true;

    emit({
      status:
        EMPLOYEE_ADMIN_ACTION_STATUS.PENDING,
      error: null,
      data: null,
    });

    try {
      const data = await action();

      emit({
        status:
          EMPLOYEE_ADMIN_ACTION_STATUS.SUCCESS,
        error: null,
        data,
      });

      return {
        accepted: true,
        status:
          EMPLOYEE_ADMIN_ACTION_STATUS.SUCCESS,
        data,
      };
    } catch (error) {
      const status =
        classifyEmployeeAdminActionError(
          error,
        );

      emit({
        status,
        error,
        data: null,
      });

      throw error;
    } finally {
      pending = false;
    }
  };

  return {
    run,

    isPending() {
      return pending;
    },
  };
}
